<template>
  <div>
    <v-list
      class="changelogentry-list"
      two-line
    >
      <v-list-tile
        class="changelogentry-list-tile list-tile-auto-height"
        @click="onEntryClicked()"
      >
        <div
          v-if="previewImageUrl"
          class="preview-image-container"
          :class="{small: $vuetify.breakpoint.xs}"
        >
          <img
            :src="previewImageUrl"
            class="preview-image mr-auto"
          >
        </div>
        <v-list-tile-content class="pa-2">
          <v-list-tile-title class="auto-height">
            <small class="grey--text caption">{{
              changelogentry.created_at | dayjs('DD.MM.YYYY')
            }}</small>
            <v-layout align-baseline>
              <strong
                class="msr--text"
                style="text-transform: uppercase"
              >{{
                prefix
              }}</strong>
              <span
                class="ml-2 grey--text text--darken-3 wrap"
                style="font-size: 1.1em"
              >
                {{ changelogentry.title }}
                <span
                  v-if="
                    changelogentry.is_beta &&
                      $store.state.common.showBetaFeatureMarkers
                  "
                  class="beta-feature-marker"
                />
              </span>
            </v-layout>
          </v-list-tile-title>
          <!-- Text Preview -->
          <v-list-tile-sub-title class="mt-1 changelog-message-preview">
            <vue-markdown
              :source="changelogentry.message"
              style="pointer-events: none"
            />
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider
        v-if="showDivider"
        class="mt-2 mb-1"
      />
    </v-list>
    <!-- Dialog -->
    <v-dialog
      v-model="showDialog"
      :width="800"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      lazy
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-layout class="headline">
            <v-layout
              align-center
              justify-center
            >
              <span class="text-xs-center">{{ changelogentry.title }}</span>
              <v-btn
                class="ml-auto mr-0 my-0"
                flat
                icon
                :title="$t('close')"
                @click="showDialog = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <span
            v-if="
              changelogentry.is_beta &&
                $store.state.common.showBetaFeatureMarkers
            "
            class="beta-feature-marker"
          />
          <div class="body-2 grey--text text--darken-1 mb-2">
            {{ changelogentry.created_at | dayjs('DD.MM.YYYY') }}
          </div>
          <div class="changelogentry-message-markdown subheading">
            <vue-markdown :source="changelogentry.message" />
          </div>
          <v-layout
            justify-center
            class="mt-3"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              style="max-width: 100%; max-height: 640px; object-fit: contain"
            >
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <btn-ok
            round
            @click="showDialog = false"
          />
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    VueMarkdown,
    BtnOk,
  },
  props: {
    changelogentry: {
      type: Object,
      required: true,
    },
    showDivider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    prefix() {
      if (this.changelogentry.kind === 'ADVERT') {
        return this.$t('advert');
      }
      return this.$t('new');
    },
    imageUrl() {
      return this.changelogentry.image_url || null;
    },
    previewImageUrl() {
      return this.changelogentry.preview_image_url || null;
    },
    extraInfoUrl() {
      return this.changelogentry.extra_info_url || null;
    },
  },
  methods: {
    onEntryClicked() {
      if (this.extraInfoUrl) {
        // Opening an external URL needs extra care when used within a
        // WebView, see goToExtraInfoUrl().
        this.goToExtraInfoUrl();
        return;
      }
      this.showDialog = true;
    },
    goToExtraInfoUrl() {
      this.$bus.$emit('alert-info', {message: this.$t('redirect')});
      setTimeout(() => {
        if (this.$store.state.common.runtimeEnv.android) {
          // Android app wrapper support for this added in v1.1.1.
          window.open(this.extraInfoUrl, '_blank');
          return;
        }
        // Should work for all browsers and the iOS WebView.
        window.location.href = this.extraInfoUrl;
      }, 750);
    },
  },
};
</script>

<style scoped>
.v-list .changelogentry-list-tile .v-list__tile .v-list__tile__title {
  min-height: 24px;
}
.v-list .changelogentry-list-tile .v-list__tile .v-list__tile__sub-title {
  max-height: 40px;
}

.preview-image-container {
  min-width: 72px;
  min-height: 64px;
  display: flex;
  overflow: hidden;
}
.preview-image-container.small {
  min-width: 64px;
  min-height: 56px;
}

.preview-image {
  max-width: 128px;
  max-height: 64px;
  object-fit: cover;
}
.small .preview-image {
  max-width: 96px;
  max-height: 48px;
}

.changelog-message-preview {
  /* https://stackoverflow.com/questions/33058004/applying-an-ellipsis-to-multiline-text */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.changelogentry-message-markdown img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangelogEntry.vue